// **********************************************************
// Gallery Module
// **********************************************************

const galleryModuleSlider = document.querySelectorAll('[data-slider="gallery-slider"]');

const galleryModuleSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 16,
  watchOverflow: true,
  autoHeight: true,
  observer: true,
  observeParents: true,
  loop: true,
  effect: 'fade',
  fadeEffect: { crossFade: true },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

galleryModuleSlider.forEach((el) => {
  const parentEle = el.closest('.gallery-module');
  const arrowRight = parentEle.querySelector('.arrow-right');
  const arrowLeft = parentEle.querySelector('.arrow-left');
  galleryModuleSliderOptions.navigation.nextEl = arrowRight;
  galleryModuleSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, galleryModuleSliderOptions);
});
